"use client";

import { trimImageUrl } from "@/lib/profile-chrome-colors";

type Input = {
  avatarUrl: string | null | undefined;
  bannerUrl: string | null | undefined;
};

type Output = {
  coverPlaceholderReady: boolean;
};

export function useProfileChromeColors(input: Input): Output {
  const hasBanner = trimImageUrl(input.bannerUrl).length > 0;
  const hasAvatar = trimImageUrl(input.avatarUrl).length > 0;

  return {
    coverPlaceholderReady: !hasAvatar || hasBanner,
  };
}
